import React from 'react';
import {
  Sheet,
  SheetContent,
  SheetFooter,
  SheetHeader,
  SheetTitle,
} from '@frontend/shadcn/components/ui/sheet';
import { Button } from '@frontend/shadcn/components/ui/button';
import { PenToSquareIcon } from '@revfluence/fresh-icons/regular/esm';
import { StarsIcon } from '@revfluence/fresh-icons/regular/esm';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { RefreshManageOfferItem } from '../ManageOffer/RefreshManageOfferItem';
import { BoostCards } from './BoostCards';
import { BULK_BOOSTS_MODES } from '../../utils';

interface IProps {
  open: boolean;
  setIsBulkBoostsModalOpen: (open: boolean) => void;
}

export const BoostApprovalDrawer: React.FC<IProps> = ({
  open,
  setIsBulkBoostsModalOpen
}) => {
  const [selectedId, setSelectedId] = React.useState<number | null>(null);
  const [step, setStep] = React.useState<BULK_BOOSTS_MODES | null>(null);
  const onClose = () => {
    setIsBulkBoostsModalOpen(false);
    setStep(null);
  };
  const goBack = () => {
    setStep(null);
  };
  const handleSteps = (mode: BULK_BOOSTS_MODES | null) => {
    setStep(mode);
    // TODO: Implement step tracking logic if needed
  };
  const handleApprove = () => {
    // TODO: Implement bulk approve/reject logic
    if (!selectedId) {
      console.warn('No boost selected for bulk action');
    }
    // Implement actual approve/reject functionality here
  };
  return (
    <Sheet open={open} onOpenChange={onClose}>
      <SheetContent side="right" className="flex flex-col h-full bg-grey-0 p-0 gap-0 w-[572px] !max-w-[572px] overflow-x-hidden">
        <SheetHeader className="flex items-center gap-2 flex-row p-4">
          <SheetTitle className="!m-0 text-base font-medium">Bulk Manage Boosts</SheetTitle>
        </SheetHeader>
        <div className="border-b" />
        <div className="bg-grey-1 flex gap-2 py-2 px-4 border-b items-center">
          <Button
            onClick={goBack}
            key={2}
            className="w-8 h-8"
            variant="outline"
            size="sm"
          >
            <FontAwesomeIcon icon={faArrowLeft} className="text-grey-6 w-4 h-4" />
          </Button>
          <div className="bg-grey-2 rounded-full w-6 h-6 flex items-center justify-center">
            <PenToSquareIcon className="h-3 w-3" />
          </div>
          <p className="text-sm font-medium text-primary m-0">113 Members Selected</p>
        </div>
        {step === null && (
          <div className="p-4 flex flex-col gap-2">
            <p className="text-sm font-medium text-primary m-0">Boost Actions</p>
            <p className="text-sm font-normal text-grey-5 m-0">Approve or reject cash, discount, or gift product rewards earned by members.</p>
            <RefreshManageOfferItem
              title="Approve Boosts"
              icon={
                <div className="bg-pink-4 p-2 rounded-md w-6 h-6 flex items-center justify-center">
                  <StarsIcon className="text-grey-0" fontSize={18} />
                </div>
              }
              onClick={() => handleSteps(BULK_BOOSTS_MODES.APPROVE)}
              hoverText="Select"
            />
            <RefreshManageOfferItem
              title="Reject Boosts"
              icon={
                <div className="bg-green-4 p-2 rounded-md w-6 h-6 flex items-center justify-center">
                  <StarsIcon className="text-grey-0" fontSize={18} />
                </div>
              }
              onClick={() => handleSteps(BULK_BOOSTS_MODES.REJECT)}
              hoverText="Select"
            />
          </div>
        )}

        {(step === BULK_BOOSTS_MODES.APPROVE || step === BULK_BOOSTS_MODES.REJECT) && (
          <BoostCards selectedId={selectedId} setSelectedId={setSelectedId} />
        )}
        {(step === BULK_BOOSTS_MODES.APPROVE || step === BULK_BOOSTS_MODES.REJECT) && (
          <SheetFooter className="justify-start sm:justify-start p-4 absolute bottom-0 left-0 right-0 w-full border-t bg-grey-0 z-[99]">
            <Button variant="primary" className="w-max" onClick={handleApprove}>
              {step === BULK_BOOSTS_MODES.APPROVE ? 'Approve' : 'Reject'}
            </Button>
            <Button onClick={onClose} variant="outline" className="w-max">
              Cancel
            </Button>
          </SheetFooter>
        )}
      </SheetContent>
    </Sheet>
  );
};
